import React, { useContext, useEffect } from "react";
import AuthContext from "../../store/auth-context";
import { GlobalContext } from "../../store/global-context";
import { SESSION_EXPIRED } from "../LoginRegisterForm/signInChecks";
import PortalShell from "./PortalShell";
import UserSideListView from "../User/UserSideListView";

/** True when `user` (AuthContext's) is a signed-in, approved Investor: the one account that sees the investor
 *  navigation. Operations users and Investors awaiting approval do not. */
export const showsInvestorShell = (user) => Boolean(user) && !user.is_admin && Boolean(user.is_verified);

/**
 * The layout for a page anyone can open, signed in or not (v1.3 ticket 12: Accessibility help, RCMC-15). Unlike the
 * signed-in layouts it sits outside LoadingComponent, so it never sends a visitor to sign-in.
 * A signed-in Investor gets the portal shell with the investor navigation (the page's own link marked current);
 * anyone else the same shell without navigation — one main region, the page title from the route — and so no skip
 * link (nothing to skip). Until a stored session's user details arrive, the page shows without navigation: help is
 * never held back by a slow or refused session.
 * A session that ends here (RCMC-22: refused by the server, or its token refresh failed) is announced as on any other
 * page, "Your session has expired. …", but the page stays: it is public, and sign-in is one link away on it. The
 * announcement is made once: the sign-in screen does not repeat it.
 */
const PublicPageLayout = () => {
  const { user, sessionExpired, clearSessionExpired } = useContext(AuthContext);
  const globalCtx = useContext(GlobalContext);

  useEffect(() => {
    if (!sessionExpired) return;
    globalCtx.raiseAlert(SESSION_EXPIRED, "success"); // the status region, as on the sign-in screen
    clearSessionExpired();
  }, [sessionExpired, clearSessionExpired, globalCtx]);

  return <PortalShell navigation={showsInvestorShell(user) ? <UserSideListView /> : null} />;
};

export default PublicPageLayout;
